<template>
  <div class="no-group">
    <div class="group-content">
      <div class="group-title">就诊流程_上传Md5</div>
      <div class="model-type">
        <p><label class="ex-label">文件名称：</label>协作组条码_测序中心条码_检测项目+任意字符</p>
        <p><label class="ex-label">文件后缀：</label>.md5</p>
        <p><label class="ex-label">文件内容：</label>fq文件名+空格+md5值</p>
        <p>样例：</p>
        <p><label class="ex-label">名称：</label>
          RL10006_30D00961_RNA-seq_20201110142324.md5</p>
        <p><label class="ex-label">内容：</label>
          RL10006_30D00961_RNA-seq_R1_20201110142324.fq.gz aa51ebef38558052d1e48e955257c3e1<br />
          <span class="ml"></span> RL10006_30D00961_RNA-seq_R2_20201110142324.fq.gz
          b8f0078960aaef18673690f0e734d595
        </p>
      </div>
      <div class="wei_des">
        MD5文件：
        <a-upload name="file" :file-list="fileList" :remove="handleRemove" :beforeUpload="beforeUpload"
          :multiple="false">
          <a-button>
            选择文件
          </a-button>
        </a-upload>
      </div>
      <div style="margin-top:10px">
        <a-button type="primary" @click="submit()" :loading="isHttpSubmit" style="margin-right:16px;">上传
        </a-button>
        <a-button @click="cancel()">取消</a-button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      isHttpSubmit: false,
      fileList: [],//限制1条
      path: '',
      fqData: []
    };
  },
  mounted() {
    this.getUploadUrl();
  },
  methods: {
    getUploadUrl() {
      let patientItemId = this.data.id;
      this.$get("patientitem/patientItem/getFqUploadPath?patientItemId=" + patientItemId + "").then(
        res => {
          this.path = res.data.data;
        }
      );
      this.$get('/uploadfq/uploadFq/getFqList', {
        bid: this.data.id
      }).then(
        res => {
          this.fqData = res.data.data;
        }
      );
    },
    cancel() {
      this.$emit('close')
    },
    handleRemove(file) {
      this.fileList = null;
    },
    getFileSuffix(name) {
      let index1 = name.lastIndexOf(".");
      let index2 = name.length;
      let suffix = '';
      if (index1 != -1) {
        suffix = name.substring(index1 + 1, index2);//后缀名
      }
      return suffix;
    },
    // 上传前事件
    beforeUpload(file) {
      const name = `${this.data.hosBarCode}_${this.data.barCode}_${this.data.applyItemNameDict}`;
      
      if (file.name.indexOf(name) != 0) {
        this.$message.error(
          "md5文件名称错误"
        );
        return false;
      } else if (this.getFileSuffix(file.name) != 'md5') {
        this.$message.error(
          "请上传指定后缀为md5的文件"
        );
        return false;
      }
      this.fileList = [file];
      return false;
    },
    submit() {
      const file = this.fileList[0];
      if (!file) {
        this.$message.error(
          "请选择md5文件"
        );
        return false;
      }
      this.isHttpSubmit = true;
      const self = this;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("path", this.path);
      this.$upload("fileupload/uploadFqFile", formData).then(
        res => {
          self.isHttpSubmit = false;
          if (res.data.code == 1) {
            self.$message.success('上传MD5成功！').then(res => {
              if (self.fqData.length == 2) {
                self.endAjaxUpload();
              }
              self.$emit('close');
            });
          } else {
            self.$message.error("上传失败");
          }
        }, err => {
          self.isHttpSubmit = false;
        }
      );
    },
    endAjaxUpload() {
      this.$post(
        "uploadfq/uploadFq/uploadFq?operateType=fq-upload-success",
        this.fqData[0],
        true
      ).then(
        res => {
          if (res.data.message.indexOf('md5校验未通过') > -1) {
            this.$message.error(res.data.message);
          }
        },
        err => {
          this.$message.error(err.data.message);
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.group-content {
  height: 500px;
  width: 700px;
  margin: 82px auto 0;

  .group-title {
    font-size: 26px;
    color: rgba(51, 51, 51, 1);
  }

  .model-type {
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    margin: 25px 0;
  }

  .isErr {
    border: 1px solid red;
  }

  .ex-label {
    color: #a0a0a0;
  }

  .ml {
    margin-left: 46px;
  }
}

.wei_des {
  margin-top: 19px;
  margin-bottom: 29px;
}
</style>